var _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurtain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_243866495451506517572222095449021093337",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 5.5,
    r: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4.75,
    width: 20,
    height: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 25.8233V5.8H12V25.8C12 25.8 11.9618 26.28 11.7778 26.5C11.6434 26.6606 11.5427 26.8 11.3333 26.8C11.1239 26.8 10.8889 26.5 10.8889 26.5C10.8889 26.5 10.8803 26 10.6667 26C10.453 26 10.4444 26.5 10.4444 26.5C10.4444 26.5 10.2094 26.8 10 26.8C9.7906 26.8 9.70873 26.7681 9.55556 26.5C9.45868 26.3305 9.54701 26 9.33333 26C9.11965 26 9.11111 26.5 9.11111 26.5C9.11111 26.5 8.87607 26.8 8.66667 26.8C8.45726 26.8 8.35639 26.6608 8.22222 26.5C8.044 26.2864 8 25.8233 8 25.8233Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.67,
    y1: 11.4,
    x2: 10.67,
    y2: 23.6,
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.33,
    y1: 8.4,
    x2: 9.33,
    y2: 20.6,
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 25.8233V5.8H24V25.8C24 25.8 23.9618 26.28 23.7778 26.5C23.6434 26.6606 23.5427 26.8 23.3333 26.8C23.1239 26.8 22.8889 26.5 22.8889 26.5C22.8889 26.5 22.8803 26 22.6667 26C22.453 26 22.4444 26.5 22.4444 26.5C22.4444 26.5 22.2094 26.8 22 26.8C21.7906 26.8 21.7087 26.7681 21.5556 26.5C21.4587 26.3305 21.547 26 21.3333 26C21.1197 26 21.1111 26.5 21.1111 26.5C21.1111 26.5 20.8761 26.8 20.6667 26.8C20.4573 26.8 20.3564 26.6608 20.2222 26.5C20.044 26.2864 20 25.8233 20 25.8233Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.67,
    y1: 8.4,
    x2: 22.67,
    y2: 20.6,
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.33,
    y1: 11.4,
    x2: 21.33,
    y2: 23.6,
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_243866495451506517572222095449021093337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V32H0V0Z",
    fill: "url(#hinava_random_uuid_4927064158241517188442271947538122601)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_4927064158241517188442271947538122601",
    x1: 16,
    y1: 10.5107,
    x2: 16,
    y2: 29.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtain);
export default __webpack_public_path__ + "static/media/curtain.92bd6cc4522b6bc1a5f37d379f27c661.svg";
export { ForwardRef as ReactComponent };